<ng-http-loader [spinner]="spinkit.skWave" [filteredUrlPatterns]="filteredUrlPatterns"></ng-http-loader>
<div class="flex-container">
	<ng-container *ngIf="!setSmartechEnable">
  		<app-header></app-header>
	</ng-container>
  <div class="flex-body">
    <div class="flex-nav">
      <ng-container *ngIf="!setSmartechEnable">
      	<app-new-main-menu></app-new-main-menu>
      </ng-container>
    </div>
    <div class="flex-content show-menu" [class.show-menu]="showMenu && (!setSmartechEnable)">
      <app-page-alert></app-page-alert>
      <div class="flex-container-inside">
        <!-- page-body -->
        <div class="flex-body page-body" [class.smartech-ce-pad]="setSmartechEnable">
          <!--bootstrap modal window for password change-->
          <ng-template #changePwdPopup let-c="close" let-d="dismiss">
            <form [formGroup]="verifyChangePwdForm">
              <div class="modal-header">
                <h4 class="modal-title">Update login password</h4>
                <!-- <button type="button" class="close" aria-label="Close" (click)="popRef.close()">
                  <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span>
                </button> -->
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label class="col-form-label bold-label" for="old_pass">Old password</label>
                  <app-show-hide-password>
                    <input type="password" placeholder="Type password" id="old_pass" class="form-control"
                           formControlName="old_pass"  #old_pass #showhideinput autocomplete="off">
                  </app-show-hide-password>
                  <small class="form-text text-danger"
                         *ngIf="!verifyChangePwdForm.controls['old_pass'].valid
           && verifyChangePwdForm.controls['old_pass'].touched
          ">Please enter valid password
                  </small>

                </div>
                <div class="form-group">
                  <label class="col-form-label bold-label" for="new_pass">New password</label>
                  <app-show-hide-password>
                    <input type="password" placeholder="Type password" id="new_pass"
                           class="form-control" formControlName="new_pass" #new_pass #showhideinput
                           (input)="checkPassword($event)" autocomplete="off">
                  </app-show-hide-password>
                  <small *ngIf="passwordData" [innerHTML]="passwordData">
                  </small>
                  <small class="form-text text-danger"
                         *ngIf="!verifyChangePwdForm.controls['new_pass'].valid
        && verifyChangePwdForm.controls['new_pass'].touched
        ">Please enter valid password
                  </small>
                </div>
                <div class="form-group">
                  <label class="col-form-label bold-label" for="confmPassword">Confirm new password</label>
                  <app-show-hide-password>
                    <input type="password" placeholder="Type confirm password" id="confmPassword" #showhideinput
                           class="form-control"
                           formControlName="confirm_pass" autocomplete="off">
                  </app-show-hide-password>
                  <small class="form-text text-danger"
                         *ngIf="!verifyChangePwdForm.controls['confirm_pass'].valid
        && verifyChangePwdForm.controls['confirm_pass'].touched
        || (verifyChangePwdForm.controls['new_pass'].value !== verifyChangePwdForm.controls['confirm_pass'].value)">
                    New password and confirmed password must be same
                  </small>
                </div>
                <app-alert *ngIf="passwordMsg" [type]="passwordType" [dismissible]="false" [value]="passwordMsg"></app-alert>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary text-uppercase"
                        [disabled]="!verifyChangePwdForm.valid || passwordFlag
                || (verifyChangePwdForm.controls['new_pass'].value !== verifyChangePwdForm.controls['confirm_pass'].value)"
                  (click)="setPassword(old_pass.value,new_pass.value)">Update Password
                </button>
                <!-- <button type="button" class="btn btn-primary text-uppercase"
                  (click)="skipSetPassword()">Skip
                </button> -->
              </div>
            </form>
          </ng-template>

          <!-- Announcement  popup -->
          <ng-template #announcePopup let-c="close" let-d="dismiss">
            <!-- <form [formGroup]="verifyChangePwdForm"> -->
              <div class="modal-header">
                <h4 class="modal-title">Netcore Email API Data Retention Policy</h4>
                <!--<button type="button" class="close" aria-label="Close" (click)="popRef.hide()">-->
                  <!--<span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> -->
                <!--</button>-->
              </div>

              <div class="modal-body">
                <p>
                  Please note that Netcore Email API retains Personally identifiable information (PII), which is limited to the email address(es), for delivering emails on behalf of the client to the intended recipient(s). But, Netcore Email API does not retain this PII data for more than 90 days from the date of transaction, post which, the email addresses will automatically get purged. <br><br>
                  Recommendation: Use Netcore Email API webhooks or reporting APIs to fetch the data before 90 days of the transaction.
                </p>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="readAnnouncement()">I Agree
                </button>
              </div>
            <!-- </form> -->
          </ng-template>
          <!-- end -->

          <div class="router-outlet">
            <router-outlet></router-outlet>
          </div>
        </div>
        <!-- <footer class="footer">
          <img src="assets/images/footer-logo.png" alt="Pepipost"><br>
          <small class="focus-less">© 2015–{{currentYear}} Pepipost® All rights reserved.
            Pepipost is a product of Netcore Solutions.
            <a
            href="https://pepipost.com/legal-security/" class="text-link" target="_blank">Privacy</a> and
            <a href="https://pepipost.com/terms-of-use/" class="text-link" target="_blank">Terms</a></small>
        </footer> -->
      </div>
    </div>
  </div>
</div>
